import config from "@/config";
export var scale_to_world_position = function (_a) {
    var x = _a.x, y = _a.y;
    return ({
        x: Math.trunc(x * config.world.dimension.boundary.width),
        y: Math.trunc(y * config.world.dimension.boundary.height),
    });
};
var UtilsPosition = {
    scale_to_world_position: scale_to_world_position,
};
export default UtilsPosition;
